import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/* api/formatDetail: mismos pattern di AdminPage (autonomo per evitare import circolari) */
const api = (token) =>
  axios.create({
    baseURL: `${API}/admin`,
    headers: { Authorization: `Bearer ${token}` },
  });

const formatDetail = (d) => {
  if (d == null) return "Errore di rete, riprova.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return d.detail ? formatDetail(d.detail) : JSON.stringify(d);
};

/* COMANDO SITO — LogiRent (Logimax): scheda "Collegamento LogiRent" (solo titolare) e
   "Sincronizzazione" (tutti gli operatori). Codice cliente segreto: cifrato nel DB, mai mostrato per intero. */

const CATS = ["CITY", "COMPACT", "SUV / CROSSOVER", "SPORT", "PREMIUM", "SCOOTER"];

export const LogirentTab = ({ token }) => {
  const [g, setG] = useState({ code_masked: "", configured: false, fonte: "logirent", broker_id: "", pickup_location: "", return_location: "", cancel_broker_id: "1" });
  const [code, setCode] = useState("");
  const [test, setTest] = useState(null);
  const [seg, setSeg] = useState({ segmenti: [], listino: {}, depositi: {}, km_giorno: 150 });
  const [busy, setBusy] = useState(false);
  const load = () => {
    api(token).get("/admin/logirent-settings").then(({ data }) => setG((x) => ({ ...x, ...data }))).catch(() => {});
    api(token).get("/admin/logirent-segmenti").then(({ data }) => setSeg(data)).catch(() => {});
  };
  useEffect(() => { load(); }, [token]);

  const prova = async () => {
    setBusy(true);
    try {
      const { data } = await api(token).post("/admin/logirent-test", {});
      setTest(data.ok ? { ok: true, msg: `Collegamento riuscito — ${data.segments} segmenti disponibili (es. ${ (data.sample || []).join(", ") })` } : { ok: false, msg: data.error || "Collegamento non riuscito" });
      if (data.ok) load();
    } catch (e) { setTest({ ok: false, msg: formatDetail(e.response?.data?.detail) || "Errore di rete" }); } finally { setBusy(false); }
  };
  const salva = async () => {
    try {
      await api(token).post("/admin/logirent-settings", { code, broker_id: g.broker_id, pickup_location: g.pickup_location, return_location: g.return_location, cancel_broker_id: g.cancel_broker_id, fonte: g.fonte });
      toast.success("Collegamento LogiRent salvato" + (code ? " (nuovo codice cifrato)" : ""));
      setCode("");
      load();
    } catch (e) { toast.error(formatDetail(e.response?.data?.detail)); }
  };
  const setRow = (i, patch) => setSeg((x) => ({ ...x, segmenti: x.segmenti.map((r, j) => (j === i ? { ...r, ...patch } : r)) }));
  const salvaSegmenti = async () => {
    try {
      await api(token).post("/admin/logirent-segmenti", { segmenti: seg.segmenti });
      toast.success("Segmenti salvati: i segmenti con prezzo sono prenotabili online");
      load();
    } catch (e) { toast.error(formatDetail(e.response?.data?.detail)); }
  };
  return (
    <div className="space-y-4" data-testid="admin-tab-logirent">
      <p className="text-xs text-gray-500">LogiRent (Logimax) è la fonte di flotta, disponibilità e prenotazioni. Il codice cliente è un segreto: resta <b>cifrato</b> nel database del sito (mai nel browser o nei log). Il collegamento al gestionale FABRI GROUP resta salvato: si sceglie la fonte qui sotto.</p>
      <div className="bg-white border border-gray-200 rounded-xl p-3 space-y-3">
        <p className="text-sm font-extrabold text-fr-navy">Collegamento</p>
        <label className="block text-[10px] font-bold text-gray-400 uppercase">Codice cliente {g.code_masked && <span className="font-mono normal-case text-gray-500">(attuale: {g.code_masked})</span>}
          <input value={code} onChange={(e) => setCode(e.target.value)} placeholder="incolla il codice cliente Logimax" className="mt-1 w-full h-10 rounded-lg border border-gray-200 bg-gray-50 px-3 text-sm font-mono" data-testid="logirent-code" />
        </label>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
          <label className="block text-[10px] font-bold text-gray-400 uppercase">Broker
            <input value={g.broker_id} onChange={(e) => setG({ ...g, broker_id: e.target.value })} className="mt-1 h-9 w-full rounded-lg border border-gray-200 bg-gray-50 px-2 text-sm" data-testid="logirent-broker" />
          </label>
          <label className="block text-[10px] font-bold text-gray-400 uppercase">Sede ritiro
            <input value={g.pickup_location} onChange={(e) => setG({ ...g, pickup_location: e.target.value })} className="mt-1 h-9 w-full rounded-lg border border-gray-200 bg-gray-50 px-2 text-sm" data-testid="logirent-pickup" />
          </label>
          <label className="block text-[10px] font-bold text-gray-400 uppercase">Sede riconsegna
            <input value={g.return_location} onChange={(e) => setG({ ...g, return_location: e.target.value })} className="mt-1 h-9 w-full rounded-lg border border-gray-200 bg-gray-50 px-2 text-sm" data-testid="logirent-return" />
          </label>
          <label className="block text-[10px] font-bold text-gray-400 uppercase">Broker annullamenti
            <input value={g.cancel_broker_id} onChange={(e) => setG({ ...g, cancel_broker_id: e.target.value })} className="mt-1 h-9 w-full rounded-lg border border-gray-200 bg-gray-50 px-2 text-sm" data-testid="logirent-cancel-broker" />
          </label>
        </div>
        <label className="block text-[10px] font-bold text-gray-400 uppercase">Fonte prenotazioni
          <select value={g.fonte} onChange={(e) => setG({ ...g, fonte: e.target.value })} className="mt-1 h-9 w-full rounded-lg border border-gray-200 bg-gray-50 px-2 text-sm" data-testid="logirent-fonte">
            <option value="logirent">LogiRent (Logimax)</option>
            <option value="gestionale">Gestionale FABRI GROUP</option>
          </select>
        </label>
        <div className="flex flex-wrap gap-2">
          <button onClick={prova} disabled={busy} className="h-9 rounded-lg border border-fr-navy text-fr-navy text-xs font-bold px-4 disabled:opacity-50" data-testid="logirent-test">Prova collegamento</button>
          <button onClick={salva} disabled={busy} className="h-9 rounded-lg bg-fr-navy text-white text-xs font-bold px-4" data-testid="logirent-save">Salva</button>
          {g.configured && <span className="text-xs font-bold text-green-700 self-center" data-testid="logirent-configured-badge">● CONFIGURATO ({g.code_masked}) — fonte: {g.fonte}</span>}
        </div>
        {test && <p className={`text-xs font-bold p-2 rounded-lg ${test.ok ? "bg-green-50 text-green-800" : "bg-red-50 text-fr-red"}`} data-testid="logirent-test-result">{test.ok ? "✓ " : "✗ "}{test.msg}</p>}
      </div>

      <div className="bg-white border border-gray-200 rounded-xl p-3" data-testid="logirent-segmenti">
        <div className="flex items-center justify-between">
          <p className="text-sm font-extrabold text-fr-navy">Segmenti LogiRent (nome, foto, prezzi, prenotabile)</p>
          <button onClick={salvaSegmenti} className="h-8 rounded-lg bg-fr-navy text-white text-xs font-bold px-3" data-testid="logirent-segmenti-save">Salva segmenti</button>
        </div>
        <p className="text-[10px] text-gray-400 mt-1">Listino iniziale (modificabile per segmento): 1g €{seg.listino?.p1g} • 2g €{seg.listino?.p2g} • 3 feriali €{seg.listino?.p3f} • lun-ven €{seg.listino?.plv} • weekend €{seg.listino?.pwe} • 7g €{seg.listino?.p7g} • 30g €{seg.listino?.p30g}. Cauzioni: Basic €{seg.depositi?.Basic} • Kasko €{seg.depositi?.Kasko} • Full Kasko €{seg.depositi?.["Full Kasko"]}. Km inclusi {seg.km_giorno}/giorno. Segmenti senza prezzo configurato = non prenotabili online.</p>
        <div className="mt-2 overflow-x-auto">
          <table className="w-full text-xs">
            <thead>
              <tr className="text-left text-[10px] text-gray-400 uppercase">
                <th className="pr-2">VehicleID</th><th className="pr-2">Nome mostrato</th><th className="pr-2">Foto (URL)</th><th className="pr-2">Categoria</th><th className="pr-2">1g</th><th className="pr-2">2g</th><th className="pr-2">3 fer.</th><th className="pr-2">lun-ven</th><th className="pr-2">weekend</th><th className="pr-2">7g</th><th className="pr-2">30g</th><th className="pr-2">Confronto Logimax</th><th>Prenotabile</th>
              </tr>
            </thead>
            <tbody>
              {seg.segmenti.map((r, i) => (
                <tr key={r.vehicle_id} className="border-t border-gray-100" data-testid={`logirent-seg-row-${i}`}>
                  <td className="pr-2 font-mono">{r.vehicle_id}</td>
                  <td className="pr-2"><input value={r.nome || ""} onChange={(e) => setRow(i, { nome: e.target.value })} className="h-8 w-36 rounded border border-gray-200 px-2" data-testid={`logirent-seg-nome-${i}`} /></td>
                  <td className="pr-2"><input value={r.foto || ""} onChange={(e) => setRow(i, { foto: e.target.value })} className="h-8 w-40 rounded border border-gray-200 px-2" data-testid={`logirent-seg-foto-${i}`} /></td>
                  <td className="pr-2">
                    <select value={r.categoria || "CITY"} onChange={(e) => setRow(i, { categoria: e.target.value })} className="h-8 rounded border border-gray-200 px-1" data-testid={`logirent-seg-cat-${i}`}>
                      {CATS.map((c) => <option key={c} value={c}>{c}</option>)}
                    </select>
                  </td>
                  {["p1g", "p2g", "p3f", "plv", "pwe", "p7g", "p30g"].map((k) => (
                    <td key={k} className="pr-2">
                      <input type="number" step="0.01" value={r.prezzi?.[k] ?? ""} onChange={(e) => setRow(i, { prezzi: { ...(r.prezzi || {}), [k]: e.target.value } })} className="h-8 w-16 rounded border border-gray-200 px-1" data-testid={`logirent-seg-${k}-${i}`} />
                    </td>
                  ))}
                  <td className="pr-2 text-gray-400 font-mono">{r.daily_amount || "—"}</td>
                  <td><input type="checkbox" checked={!!r.prenotabile} onChange={(e) => setRow(i, { prenotabile: e.target.checked })} className="accent-fr-navy" data-testid={`logirent-seg-prenotabile-${i}`} /></td>
                </tr>
              ))}
            </tbody>
          </table>
          {!seg.segmenti.length && <p className="text-xs text-gray-400 py-3">Nessun segmento ancora: premi "Prova collegamento" per importarli dalla disponibilità reale.</p>}
        </div>
      </div>
    </div>
  );
};

export const LogirentSyncTab = ({ token }) => {
  const [data, setData] = useState(null);
  const load = () => { api(token).get("/admin/logirent-sync").then(({ data }) => setData(data)).catch(() => {}); };
  useEffect(() => { load(); }, [token]);
  const annulla = async (reference) => {
    try {
      await api(token).post("/admin/logirent-cancel", { reference });
      toast.success(`Annullata in LogiRent: ${reference}`);
      load();
    } catch (e) { toast.error(formatDetail(e.response?.data?.detail)); }
  };
  return (
    <div className="space-y-4" data-testid="admin-tab-logirent-sync">
      <p className="text-xs text-gray-500">Prenotazioni LogiRent, coda di sincronizzazione (PENDING → PROCESSING → SYNCED / FAILED / REQUIRES_REVIEW), eventi e conflitti. Le prenotazioni restano Pending in LogiRent: la conferma lì spetta al titolare.</p>
      <div className="bg-white border border-gray-200 rounded-xl p-3" data-testid="logirent-sync-bookings">
        <p className="text-sm font-extrabold text-fr-navy">Prenotazioni con LogiRent</p>
        <div className="mt-2 overflow-x-auto">
          <table className="w-full text-xs">
            <thead><tr className="text-left text-[10px] text-gray-400 uppercase"><th className="pr-2">Riferimento</th><th className="pr-2">Stato sito</th><th className="pr-2">Reservation</th><th className="pr-2">Voucher</th><th className="pr-2">Stato LogiRent</th><th className="pr-2">Totale</th><th></th></tr></thead>
            <tbody>
              {(data?.bookings || []).map((b, i) => (
                <tr key={b.reference} className="border-t border-gray-100" data-testid={`lr-booking-row-${i}`}>
                  <td className="pr-2 font-mono">{b.reference}</td>
                  <td className="pr-2">{b.status}</td>
                  <td className="pr-2 font-mono">{b.logirent?.reservation_number || "—"}</td>
                  <td className="pr-2 font-mono">{b.logirent?.voucher_number || "—"}</td>
                  <td className="pr-2">{b.logirent?.status || "—"}</td>
                  <td className="pr-2">€{b.price_snapshot?.total ?? b.total_price ?? "—"}</td>
                  <td>
                    {b.status === "richiesta" && (
                      <button onClick={() => annulla(b.reference)} className="h-7 rounded-lg bg-fr-red text-white text-[10px] font-bold px-2" data-testid={`lr-cancel-${b.reference}`}>Annulla in LogiRent</button>
                    )}
                  </td>
                </tr>
              ))}
              {!data?.bookings?.length && <tr><td colSpan={7} className="text-gray-400 py-3">Nessuna prenotazione LogiRent.</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
      <div className="bg-white border border-gray-200 rounded-xl p-3" data-testid="logirent-sync-queue">
        <p className="text-sm font-extrabold text-fr-navy">Coda e conflitti</p>
        <ul className="mt-2 space-y-1 text-xs">
          {(data?.queue || []).map((q, i) => (
            <li key={i} className={`rounded-lg p-2 ${q.status === "SYNCED" ? "bg-green-50 text-green-900" : q.status === "REQUIRES_REVIEW" ? "bg-red-50 text-fr-red" : "bg-amber-50 text-amber-900"}`} data-testid={`lr-queue-item-${i}`}>
              <b>{q.status}</b> · {q.kind} · <span className="font-mono">{q.external_reference}</span>{q.last_error ? ` · ${q.last_error}` : ""}
            </li>
          ))}
          {!data?.queue?.length && <li className="text-gray-400 py-2">Coda vuota: nessuna operazione in sospeso.</li>}
        </ul>
      </div>
      <div className="bg-white border border-gray-200 rounded-xl p-3" data-testid="logirent-sync-events">
        <p className="text-sm font-extrabold text-fr-navy">Registro eventi</p>
        <ul className="mt-2 space-y-1 text-[11px] text-gray-600 font-mono max-h-64 overflow-y-auto">
          {(data?.events || []).map((e, i) => <li key={i} data-testid={`lr-event-${i}`}>{e.ts} · {e.event} · {e.external_reference || ""} {e.detail || ""}</li>)}
          {!data?.events?.length && <li className="text-gray-400">Nessun evento.</li>}
        </ul>
      </div>
    </div>
  );
};
